import { Button } from '@fluentui/react-components'
import { PersonBoard24Regular } from '@fluentui/react-icons'
import { useSearchParams } from 'react-router-dom'
import { RestSchemas } from '@/contexts/QueryProvider'

type MessagesApplicationsApplication = RestSchemas['Messages.Applications.Application']
export function RolesCellContent({ item }: { item: MessagesApplicationsApplication }) {
  const [searchParams, setSearchParams] = useSearchParams()
  return (
    <>
      {item.roleCount}
      <Button
        appearance="subtle"
        icon={<PersonBoard24Regular />}
        onClick={() => {
          searchParams.set('tab', 'roles')
          searchParams.set('appId', item.applicationId.toString())
          searchParams.set('appName', item.appName)
          setSearchParams(searchParams)
        }}
      />
    </>
  )
}
